import { FormattedMessage } from "react-intl";

import { MaxIcon, MinIcon } from "@citrine/atoms/icons";
import { TruncatedText } from "@citrine/atoms/truncated-text";
import { Comparison } from "@citrine/resources/constraint";
import type { IObjective } from "@citrine/resources/objective";
import { coerceIfInfinity } from "@citrine/utils/number";
import { trimExcessSignificance } from "@citrine/utils/rounding";

import { DescriptorKey } from "#src/components/descriptor-key";

import { Value } from "../value";

import * as sx from "./index.sx";

export const slots = { Icon: sx.Icon };

export function Objective({
  className,
  objective,
  baseline,
  omitIcon,
  units,
  tooltip,
}: {
  className?: string;
  objective?: IObjective;
  baseline?: number;
  omitIcon?: boolean;
  units?: string;
  tooltip?: boolean;
}) {
  return objective ? (
    <TruncatedText tooltip={tooltip} fullWidthTooltip>
      <sx.Objective className={className}>
        {omitIcon ? null : (
          <sx.Icon as={objective.type === "ScalarMax" ? MaxIcon : MinIcon} />
        )}
        <sx.Descriptor>
          <DescriptorKey descriptorKey={objective.descriptor_key} />
        </sx.Descriptor>
        {baseline == null ? null : (
          <sx.Baseline>
            <sx.Operator>
              {objective.type === "ScalarMax" ? Comparison.GT : Comparison.LT}
            </sx.Operator>
            <span>
              <Value
                value={trimExcessSignificance(coerceIfInfinity(baseline))}
                units={units}
              />
            </span>
          </sx.Baseline>
        )}
      </sx.Objective>
    </TruncatedText>
  ) : (
    <FormattedMessage id="resources.objective.no-objectives" />
  );
}
